export enum PresentationsApi {
  Presentations = '/api/v1.0/presentations',
  Presentation = '/WebAPI/getpresentation',
  CreatePresentation = '/WebAPI/CreatePresentation',
  ModifyPresentation = '/WebAPI/ModifyPresentation',
  DeletePresentation = '/WebAPI/DeletePresentation'
}
